import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=bdb15b98&scoped=true&"
import script from "./LoginButton.js?vue&type=script&lang=js&"
export * from "./LoginButton.js?vue&type=script&lang=js&"
import style0 from "./LoginButton.scss?vue&type=style&index=0&id=bdb15b98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb15b98",
  null
  
)

export default component.exports